import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

import "core-js/modules/es.array.concat.js";

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { keyframes } from '@emotion/react'; // --- Login page animations ---

var fadeInUp = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  from {\n    opacity: 0;\n    transform: translateY(24px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n"])));
var scaleIn = keyframes(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  from {\n    opacity: 0;\n    transform: scale(0.85);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n"])));
var shimmer = keyframes(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  0% {\n    background-position: -200% 0;\n  }\n  100% {\n    background-position: 200% 0;\n  }\n"])));
var gradientShift = keyframes(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  0% {\n    background-position: 0% 50%;\n  }\n  50% {\n    background-position: 100% 50%;\n  }\n  100% {\n    background-position: 0% 50%;\n  }\n"])));
var iconFloat = keyframes(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  0%, 100% {\n    transform: translateY(0);\n  }\n  50% {\n    transform: translateY(-4px);\n  }\n"])));
export var publicContentContainer = function publicContentContainer(theme) {
  return {
    width: '100%',
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: "linear-gradient(135deg, ".concat(theme.gray800, " 0%, ").concat(theme.primaryDark, " 50%, ").concat(theme.gray800, " 100%)"),
    backgroundSize: '200% 200%',
    animation: "".concat(gradientShift, " 12s ease infinite"),
    padding: '2em',
    position: 'relative',
    overflow: 'hidden',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: '-50%',
      left: '-50%',
      width: '200%',
      height: '200%',
      background: 'radial-gradient(circle at 30% 50%, rgba(79, 70, 229, 0.15) 0%, transparent 50%), radial-gradient(circle at 70% 80%, rgba(99, 102, 241, 0.1) 0%, transparent 40%)',
      pointerEvents: 'none'
    }
  };
};
export var formContainer = function formContainer(theme) {
  return {
    width: '100%',
    maxWidth: 420,
    position: 'relative',
    zIndex: 1,
    animation: "".concat(scaleIn, " 0.5s cubic-bezier(0.16, 1, 0.3, 1) forwards"),
    '& .login-card': {
      backgroundColor: theme.white,
      borderRadius: 16,
      padding: '3.2em 2.8em 2.8em',
      boxShadow: '0 25px 50px -12px rgb(0 0 0 / 0.25), 0 0 0 1px rgb(255 255 255 / 0.05)',
      border: 'none',
      animation: "".concat(fadeInUp, " 0.6s cubic-bezier(0.16, 1, 0.3, 1) 0.1s both")
    },
    '@media (max-width: 480px)': {
      maxWidth: '100%',
      '& .login-card': {
        padding: '2.4em 1.8em 2em',
        borderRadius: 12
      }
    }
  };
};
export var loginHeader = function loginHeader(theme) {
  return {
    textAlign: 'center',
    marginBottom: '2.4em',
    animation: "".concat(fadeInUp, " 0.6s cubic-bezier(0.16, 1, 0.3, 1) 0.2s both"),
    '& .login-icon': {
      width: 52,
      height: 52,
      borderRadius: 14,
      background: "linear-gradient(135deg, ".concat(theme.primary, " 0%, ").concat(theme.highlight, " 100%)"),
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginBottom: '1.2em',
      boxShadow: "0 8px 24px -4px ".concat(theme.primary, "44"),
      animation: "".concat(iconFloat, " 3s ease-in-out infinite"),
      transition: 'transform 0.3s ease, box-shadow 0.3s ease',
      '&:hover': {
        transform: 'scale(1.08)',
        boxShadow: "0 12px 32px -4px ".concat(theme.primary, "66")
      },
      '& i': {
        color: theme.white,
        fontSize: 24
      }
    },
    '& h4': {
      color: theme.gray800,
      fontWeight: 700,
      fontSize: '2.2rem',
      marginBottom: '0.4em'
    },
    '& p': {
      color: theme.gray400,
      fontSize: '1.3rem'
    }
  };
};
export var loginFormAnimated = {
  '& > *:nth-child(1)': {
    animation: "".concat(fadeInUp, " 0.5s cubic-bezier(0.16, 1, 0.3, 1) 0.3s both")
  },
  '& > *:nth-child(2)': {
    animation: "".concat(fadeInUp, " 0.5s cubic-bezier(0.16, 1, 0.3, 1) 0.4s both")
  },
  '& > *:nth-child(3)': {
    animation: "".concat(fadeInUp, " 0.5s cubic-bezier(0.16, 1, 0.3, 1) 0.5s both")
  }
};
export var forgotStyles = function forgotStyles(theme) {
  return {
    fontSize: '1.2rem',
    color: theme.primary,
    fontWeight: 500,
    marginBottom: '1.2em',
    transition: 'color 0.2s ease',
    '&:hover': {
      color: theme.primaryDark
    }
  };
};
export var titleForgot = function titleForgot(theme) {
  return {
    color: theme.gray800,
    fontWeight: 600,
    marginBottom: 10,
    fontSize: 20
  };
};
export var backButton = function backButton(theme) {
  return {
    color: theme.primary,
    fontSize: 16,
    display: 'flex',
    alignItems: 'center',
    borderRadius: 8,
    border: "1px solid ".concat(theme.primary),
    padding: '0 32px',
    '&:hover': {
      backgroundColor: theme.primaryLight
    }
  };
};
export var submitButtonContainer = function submitButtonContainer(theme) {
  return {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    gap: '0.4em',
    '& button': {
      position: 'relative',
      overflow: 'hidden',
      transition: 'all 0.3s cubic-bezier(0.16, 1, 0.3, 1)',
      '&:hover': {
        transform: 'translateY(-1px)',
        boxShadow: "0 8px 20px -4px ".concat(theme.primary, "44")
      },
      '&:active': {
        transform: 'translateY(0)'
      },
      '&::after': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.15), transparent)',
        backgroundSize: '200% 100%',
        animation: "".concat(shimmer, " 2.5s ease-in-out infinite"),
        pointerEvents: 'none'
      }
    }
  };
};
export var loginFooter = function loginFooter(theme) {
  return {
    textAlign: 'center',
    marginTop: '2em',
    paddingTop: '1.6em',
    borderTop: "1px solid ".concat(theme.gray100),
    animation: "".concat(fadeInUp, " 0.5s cubic-bezier(0.16, 1, 0.3, 1) 0.6s both"),
    '& span': {
      color: theme.gray400,
      fontSize: '1.2rem'
    }
  };
};